export default function Externalvalidation() {
try {
    let userdetails = JSON.parse(
        localStorage.getItem("RBLExternalUserDetails")
    );
    if (!userdetails ||!userdetails.emailID ||!userdetails.userName ||!userdetails["User-Session-Auth-Key"]) {
        return false;
    }else {
        return true;
    }
    } catch (error) {
        console.error("Error in Externalvalidation:", error);
        return false;
    }
}
